module.exports = __webpack_public_path__ + "spire-logo.png";